import { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { LifeCycle } from '@wix/thunderbolt-symbols'
import { PageWillMountPropsExtender } from './pageWillMountPropsExtender'
import { ComponentWillMountFactory } from './componentWillMount'
import { ComponentProviderFactory } from './componentsFactory'
import { BaseTraitSymbol, ComponentDriverProviderSymbol } from './symbols'
import { EventsTraitFactory } from './traits/eventsTrait'
import { PropsTraitFactory } from './traits/propsTrait'
import { StylesTraitFactory } from './traits/stylesTrait'

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler).to(PageWillMountPropsExtender)
	bind(LifeCycle.PageWillMountHandler, LifeCycle.PageWillUnmountHandler).to(ComponentWillMountFactory)
	bind(ComponentDriverProviderSymbol).to(ComponentProviderFactory)
	bind(BaseTraitSymbol).to(EventsTraitFactory)
	bind(BaseTraitSymbol).to(StylesTraitFactory)
	bind(BaseTraitSymbol).to(PropsTraitFactory)
}

export {
	ComponentPropsExtenderSymbol,
	ComponentDriverProviderSymbol,
	ComponentWillMountSymbol,
	ComponentDriverSymbol,
	ComponentsStoreSymbol,
} from './symbols'

export {
	IComponentPropsExtender,
	ViewerComponent,
	ViewerComponentProvider,
	ComponentWillMount,
	ComponentDriverFactory,
	ComponentsStore,
} from './types'
